// La operacion en tres numeros: lo que sale hoy, lo que sale esta semana y lo
// que ya salio en el mes. Es la contraparte fisica de la tarjeta de ventas:
// una dice cuanta plata entro, esta dice cuanta comida salio.

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

import { numero } from './formato';
import { useConteo, levanta } from './motion';

function Numero({ valor, etiqueta, detalle }) {
  const enCurso = useConteo(valor, 1100);
  return (
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography sx={{ fontSize: 28, fontWeight: 800, letterSpacing: '-.5px', lineHeight: 1.1, whiteSpace: 'nowrap' }}>
        {numero(Math.round(enCurso))}
      </Typography>
      <Typography sx={{ fontSize: 13.5, fontWeight: 600 }}>{etiqueta}</Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>{detalle}</Typography>
    </Box>
  );
}

export default function PulsoOperacion({ operacion }) {
  return (
    <Card sx={{ p: 3, height: 1, ...levanta }}>
      <Typography sx={{ fontSize: 16, fontWeight: 600, mb: 2.5 }}>La operación</Typography>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={3}
        divider={<Divider orientation="vertical" flexItem />}
      >
        <Numero
          valor={operacion.pedidosHoy}
          etiqueta="pedidos hoy"
          detalle={`${numero(operacion.pedidosSemana)} hasta el domingo`}
        />
        <Numero
          valor={operacion.entregasMes}
          etiqueta="entregas del mes"
          detalle="pedidos marcados como entregados"
        />
        {/* El valor en soles de lo pendiente ya esta arriba, en su tarjeta.
            Aqui va en platos, que es la unidad con la que compra cocina. */}
        <Numero
          valor={operacion.enviosPendientes}
          etiqueta="envíos por servir"
          detalle="ya cobrados y sin consumir"
        />
      </Stack>
    </Card>
  );
}
